import React from 'react'
import {useSelector} from 'react-redux'
import {Trans} from '@lingui/macro'
import {Alert} from 'components/UI/Alert/Alert'
import {Button} from 'components/UI/Button/Button'
import {IdZreportsState} from 'model/dashboardZreports/dZreportReducer';
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';


// Type
export type typePopupPrint = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupPrint: React.FC<typePopupPrint> = ({ setOpenPopup}) => {

    const dataObject = useSelector((state: {dZReports: IdZreportsState}) => state.dZReports.detailItem)



    return (
        <>
            {dataObject
                ? <>
                    <h1 className="text-gray-90 text-center font-bold"><Trans>Tinda</Trans></h1>
                    <div className="mt-2  grid gap-x-8 grid-cols-1 border rounded-md pt-2 px-2 border-b-0">
                        <div
                            className="text-gray-90 text-center font-medium leading-4 mb-1">{dataObject.merchantName}</div>
                        <div
                            className="text-gray-90 text-center font-medium leading-4 mb-2">{dataObject.merchantAddress ? dataObject.merchantAddress : '-'}</div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between ">
                            <div className="text-gray-500 text-left leading-4"><Trans>Terminal serial number:</Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{dataObject.terminalSerianNumber}</div>
                        </div>
                        <div className=" flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="text-gray-500 text-left leading-4"><Trans>Applet version:</Trans></div>
                            <div
                                className="text-gray-90 text-left leading-4">{dataObject.softwareVersion}</div>
                        </div>
                    </div>
                    <div
                        className="grid gap-x-8 grid-cols-1 border border-t-0 border-b-0 rounded-md px-2">

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<FolderIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>User name: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left uppercase leading-4">{dataObject.userName}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4 ">
                                {/* <ScaleIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Store name: </Trans>
                            </div>
                            <div className="text-gray-90 text-left uppercase leading-4">{dataObject.store.name}</div>
                        </div>
                    </div>

                    <div className="grid gap-x-8 grid-cols-1 border rounded-md px-2 pb-2 border-t-0 mb-2">

                        <div
                            className="flex flex-wrap gap-x-4 py-1 justify-between ">
                            <div className="text-gray-500 text-left leading-4"><Trans>Fiscal card Id:</Trans></div>
                            <div
                                className="text-gray-90 text-left  leading-4">{dataObject.fiscalCardId}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="text-gray-500 text-left leading-4"><Trans>TIN:</Trans></div>
                            <div
                                className="text-gray-90 text-left  leading-4">{dataObject.tin ? dataObject.tin : '-'}</div>
                        </div>
                        <div
                            className="flex flex-wrap gap-x-4 py-1 justify-between pb-0">
                            <div className="text-gray-500 text-left leading-4"><Trans>Z-Report number:</Trans></div>
                            <div
                                className="text-gray-90 text-left font-medium leading-4">{dataObject.zreportNumber ? dataObject.zreportNumber : '-'}</div>
                        </div>

                    </div>

                    <h2 className="text-gray-90 text-center font-medium"><Trans>Close Z reports</Trans></h2>

                    <div
                        className="mt-1  grid gap-x-8 grid-cols-1 border  rounded-md px-2">
                        <h2 className="text-gray-90 text-center font-medium"><Trans>Sale</Trans></h2>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<BookmarkIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Sales with cash: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{numberCurrencyFormat(+dataObject.salesWithCash)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 border-b justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<CheckCircleIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Sales with cards:</Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{numberCurrencyFormat(+dataObject.salesWithCards)}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-1 justify-between ">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<BookmarkIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Vat amount: </Trans>
                            </div>
                            <div className="text-gray-90 text-left  leading-4">{numberCurrencyFormat(+dataObject.vatAmount)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<CheckCircleIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Sales count:</Trans>
                            </div>
                            <div className="text-gray-90 text-left ">{dataObject.salesCount}</div>
                        </div>

                    </div>

                    <div
                        className="mt-1.5 grid gap-x-8 grid-cols-1 border rounded-md px-2 ">
                        <h2 className="text-gray-90 text-center font-medium"><Trans>Refund</Trans></h2>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<PencilIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Return with cash: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left leading-4">{numberCurrencyFormat(+dataObject.returnWithCash)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 border-b justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<FolderIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Return with cards: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{numberCurrencyFormat(+dataObject.returnWithCards)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/* <TagIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Vat return amount: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{numberCurrencyFormat(+dataObject.vatReturnAmount)}</div>
                        </div>

                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/* <ScaleIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Return count: </Trans>
                            </div>
                            <div className="text-gray-90 text-left  leading-4">{dataObject.returnCount}</div>
                        </div>
                    </div>
                    <div className="mt-1.5  grid gap-x-8 grid-cols-1 border rounded-md px-2 print:mb-2" >
                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<PencilIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Open date: </Trans>
                            </div>
                            <div className="text-gray-90 text-left  leading-4">{dataObject.openDate.replace('T', ' ').substring(0,19)}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<PencilIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Close date: </Trans>
                            </div>
                            <div className="text-gray-90 text-left  leading-4">{dataObject.closeDate.replace('T', ' ').substring(0,19)}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<PencilIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>First receipt number: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{dataObject.firstReceiptNumber}</div>
                        </div>
                        <div className="flex flex-wrap gap-x-4 py-1 justify-between">
                            <div className="flex gap-x-2 items-center text-gray-500 text-left leading-4">
                                {/*<PencilIcon className="h-5 w-5 text-gray-500"/>*/}
                                <Trans>Last receipt number: </Trans>
                            </div>
                            <div
                                className="text-gray-90 text-left  leading-4">{dataObject.lastReceiptNumber}</div>
                        </div>
                    </div>

                    <div className="flex justify-end print:hidden">
                        <div className="flex gap-4 mt-5 mr-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <Button type="button" secondary={true} label={<Trans>Print</Trans>}
                                    onClick={() => {
                                        window.print();
                                        setOpenPopup(false)
                                    }}/>
                        </div>

                        <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse ">
                            <Button type="button" secondary={true} label={<Trans>Cancel</Trans>}
                                    onClick={() => setOpenPopup(false)}/>
                        </div>

                    </div>
                </>
                : <Alert type="error" title={<Trans>Have no data.</Trans>}/>
            }
        </>
    )
}
